export default __webpack_public_path__ + "static/char-53-anr-dbce60556b26b9fe45084112062732f3.webp";